export const loadScript = (src, onLoad) => {
  removeScript(src)
  const script = document.createElement('script')
  script.src = src
  document.body.appendChild(script)
  script.onload = onLoad
}

export const removeScript = async (src) => {
  const listScript = document.querySelectorAll('script')
  listScript.forEach((e) => {
    if (e.src === src || !!~e.src.indexOf(src)) {
      e.parentNode.removeChild(e)
    }
  })
}
